import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewEncapsulation, ViewChild } from '@angular/core';
import { DataService, HTTPService, HelperService } from 'app/services';
import { ChartOptions } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';
import 'chartjs-plugin-labels';
import { Subscription } from 'rxjs';
import { config } from 'app/constants';
@Component({
  selector: 'app-history-inv-sales-chart',
  templateUrl: './history-inv-sales-chart.component.html',
  styleUrls: ['./history-inv-sales-chart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HistoryInvSalesChartComponent implements OnInit, OnDestroy {
  public chartType: string = 'line';
  public chartData: any[];
  public chartLabels: any[];
  public chartColors: any[];
  public chartOptions: ChartOptions & { annotation?: any } = {};
  public lineChartPlugins: any[];
  public lineChartColors: Color[];
  stockItemdata: any;
  subscribtions: Subscription = null;
  @Input() type;
  @Input() itemId;
  @Input() label: string = '';
  @Input() rowType: string = '';
  @Output() chartHandleClick = new EventEmitter();
  @Output() scrollingFinished = new EventEmitter<boolean>();
  @ViewChild('salesContainer', { static: false })
  salesContainer: any;
  @ViewChild('reOrderContainer', { static: false })
  reOrderContainer: any;

  salesTrendData: any = null;
  config = config;
  cols: any[] = [];
  reOrderCol: any[] = [];
  salesCol: any[] = [];
  stockList = [];
  stockReorderList = [];
  locations: string[] = [];
  activeStatus: any = true;
  totalRecords: number;
  loading: boolean = true;
  tableConfigSales = {
    skip: 0,
    limit: config.shortPageSize,
  };
  tableConfigReorder = {
    skip: 0,
    limit: config.shortPageSize,
  };
  poType: string = '';
  restockLevel: string = '';
  // locations: string[] = [];
  headerOptions = {
    poType: true,
    restockLevel: true,
    supplier: true,
    location: true,
    columns: false,
  };
  lastScrollTopSales = 0;
  lastScrollTopReorder = 0;
  // itemId: string = '';

  constructor(private dataService: DataService, private httpService: HTTPService, public helperService: HelperService,) {
    this.subscribtions = this.dataService.stockItemdata.subscribe((res) => {
      if (res) {
        this.salesTrendData = res;
        this.setData();
      }
    });
  }

  ngOnInit() {
    this.reOrderCol = [
      { field: 'date', header: 'Date', className: 'sup-date' },
      { field: 'quantity', header: 'Qty', className: 'quantity' },
      { field: 'poNumber', header: 'PO#', className: 'poNumber' },
      { field: 'supplierName', header: 'Supplier', className: 'supplier-name' },
      { field: 'cost', header: 'Cost', className: 'cost' },
      { field: 'core', header: 'Core', className: 'core' },
      { field: 'supplierInvoiceDate', header: 'Supplier invoice date', className: 'supplierInvoiceDate' },
    ];
    this.salesCol = [
      { field: 'date', header: 'Date', className: 'sup-date' },
      { field: 'quantity', header: 'Qty', className: 'quantity' },
      { field: 'roNumber', header: 'RO#', className: 'roNumber' },
      { field: 'price', header: 'Price', className: 'price' },
      { field: 'cost', header: 'Cost', className: 'cost' },
      { field: 'core', header: 'Core', className: 'core' },
      { field: 'invoiceDate', header: 'Invoice date', className: 'supplierInvoiceDate' },
    ];
    // Chart data
    this.chartData = [
      {
        data: [0],
        label: ['Sales'],
      },
      {
        type: 'bar',
        data: [0],
        label: ['Purchase'],
      },
    ];
    this.chartLabels = [''];
    this.chartColors = [
      {
        // backgroundColor: '#fff',
        // borderColor: '$primary-500',
        backgroundColor: this.cssvar('--chart-bar-bg'),
        // borderColor: this.cssvar('--chart-border-color'),
        borderWidth: 3,
        pointWidth: 10,
        pointBorderWidth: 2,
        pointHoverRadius: 5,
        pointRadius: 3,
        fill: false,

        //
        borderColor: this.cssvar('--chart-border-color'),
        pointBackgroundColor: this.cssvar('--chart-pointer-color'),
        pointBorderColor: this.cssvar('--chart-pointer-hover-color'),
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(148,159,177,0.8)',
      },
      {
      },
    ];

    this.chartOptions = {
      maintainAspectRatio: false,
      responsive: true,
      layout: {
        padding: {
          right: 10,
        },
      },
      legend: {
        display: true,
        position: 'top',
        align: 'end',
        onHover: function (e) {
          // e.target.style.cursor = 'pointer';
        },
        labels: {
          fontColor: '#6e7777',
          fontSize: 12,
          boxWidth: 5,
        },
      },
      scales: {
        xAxes: [
          {
            ticks: {
              fontSize: 9,
              padding: 10,
            },
            gridLines: {
              display: true,
              drawOnChartArea: false,
              zeroLineColor: '#ffffff',
              drawBorder: true,
              drawTicks: false,
            },
          },
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: 'QTY',
              fontColor: '$secondary-900',
            },
            ticks: {
              fontSize: 12,
              maxTicksLimit: 6,
              callback: (value, index, values) => value,
            },
          },
        ],
      },
      annotation: {
        annotations: [
          {
            type: 'line',
            mode: 'horizontal',
            scaleID: 'y-axis-0',
            // value: data.avg,
            borderColor: 'var(--secondary-100)',
            borderWidth: 1,
            pointStyle: 'star',
            label: {
              enabled: false,
              content: 'Test label',
            },
          },
        ],
      },
      tooltips: {
        // Disable the on-canvas tooltip
        enabled: false,
        mode: 'nearest',
        custom: function (tooltipModel) {
          // Tooltip Element
          let tooltipEl: any = document.getElementById('chartjs-tooltip');
          // Create element on first render
          if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.innerHTML = '<div class="dashboard-custom-tooltip"></div>';
            document.body.appendChild(tooltipEl);
          } else {
            tooltipEl.id = 'chartjs-tooltip';
            tooltipEl.innerHTML = '<div class="dashboard-custom-tooltip"></div>';
            document.body.appendChild(tooltipEl);
          }
          // Hide if no tooltip
          if (tooltipModel.opacity === 0) {
            tooltipEl.style.opacity = 0;
            return;
          }
          function getBody(bodyItem) {
            return bodyItem.lines;
          }
          // Set Text
          if (tooltipModel.body) {
            const titleLines = tooltipModel.title || [];
            const bodyLines = tooltipModel.body.map(getBody);
            let innerHtml = '<div>';
            titleLines.forEach((title) => (innerHtml += title));
            innerHtml += '</div><table>';
            bodyLines.forEach((body, i) => {
              let n;
              if (!body[0].count) {
                n = 'Total Sale: 0';
              } else if (body[0].count && !body[0].supplierAndPo) {
                n = `Total Sales: ${body[0].count}`;
              } else {
                n = `<tr><td>
                ${body[0].count}
                <td></tr>`;
                // object with line
                if (body[0].supplierAndPo) {
                  body[0].supplierAndPo.forEach((element) => {
                    n += `<tr style="line-height: 100%"><td>
                    ${[element]},
                    </td></tr>`;
                  });
                }
              }
              innerHtml += n;
            });
            innerHtml += '</table>';
            const tableRoot = tooltipEl.querySelector('.dashboard-custom-tooltip');
            tableRoot.innerHTML = innerHtml;
          }
          // `this` will be the overall tooltip
          const position = this._chart.canvas.getBoundingClientRect();
          // Display, position, and set styles for font
          tooltipEl.style.opacity = 1;
          tooltipEl.style.position = 'absolute';
          tooltipEl.style.left = position.left - 56 + window.pageXOffset + tooltipModel.caretX + 'px';
          tooltipEl.style.top = position.top - 70 + window.pageYOffset + tooltipModel.caretY + 'px';
          tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
          tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
          tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
          tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
          tooltipEl.style.pointerEvents = 'none';
        },
        callbacks: {
          label: (data) => {
            if (data.datasetIndex) {
              return this.salesTrendData.reorderData.length ? this.SetPurchasesBodyText(this.salesTrendData.reorderData[data.index]) : 0;
            } else {
              return this.salesTrendData.saleData.length ? this.salesTrendData.saleData[data.index] : 0;
            }
          },
        },
      },
    };

  }


  private async getStocks() {
    await this.fetchSalesList();
    await this.fetchReOrderList();
    this.loading = false;
  }
  async fetchSalesList() {

    if (this.tableConfigSales.skip === 0) {
      this.stockList = [];
    }
    const conf = {
      skip: this.tableConfigSales.skip,
      limit: this.tableConfigSales.limit,
    };
    const salesList = await this.httpService.getReOrderTrendsList('sales', this.type, this.itemId, conf);
    this.stockList = [...this.stockList, ...salesList[0].records];
    this.totalRecords = salesList[0].metaData.totalRecords;

  }
  async fetchReOrderList() {
    if (this.tableConfigReorder.skip === 0) {
      this.stockReorderList = [];
    }
    const conf = {
      skip: this.tableConfigReorder.skip,
      limit: this.tableConfigReorder.limit,
    };
    const reOrderList = await this.httpService.getReOrderTrendsList('reOrder', this.type, this.itemId, conf);
    this.stockReorderList = [...this.stockReorderList, ...reOrderList[0].records];
  }
  onScrollSales(e) {
    if (
      this.salesContainer.nativeElement.offsetHeight + this.salesContainer.nativeElement.scrollTop >= this.salesContainer.nativeElement.scrollHeight - 1 &&
      this.salesContainer.nativeElement.scrollTop > this.lastScrollTopSales
    ) {
      this.lastScrollTopSales = this.salesContainer.nativeElement.scrollTop + 5;
      this.tableConfigSales.skip += this.tableConfigSales.limit;
      this.fetchSalesList();
    }
  }
  onScrollReOrder(e) {
    if (
      this.reOrderContainer.nativeElement.offsetHeight + this.reOrderContainer.nativeElement.scrollTop >= this.reOrderContainer.nativeElement.scrollHeight - 1 &&
      this.reOrderContainer.nativeElement.scrollTop > this.lastScrollTopReorder
    ) {
      this.lastScrollTopReorder = this.reOrderContainer.nativeElement.scrollTop + 5;
      this.tableConfigReorder.skip += this.tableConfigReorder.limit;
      this.fetchReOrderList();
    }
  }

  SetPurchasesBodyText(data) {
    const supplierAndPo = data.pos.map((e, i) => `${e ? e : 'PO not found'}` + `${data.suppliers[i] ? ' ' + data.suppliers[i] : ' Supplier not found'}`);
    const body = {
      count: `Total purchase: ${data.count}`,
      supplierAndPo,
    };
    return body;
  }

  async setData() {
    this.chartData = [
      {
        data: this.salesTrendData.saleData.length ? this.salesTrendData.saleData.map((item) => (item.count ? item.count : 0)) : [0],
        label: ['Sales'],
        fill: false,
      },
      {
        type: 'bar',
        data: this.salesTrendData.reorderData.length ? this.salesTrendData.reorderData.map((item) => (item.count ? item.count : 0)) : [0],
        label: ['Purchase'],
        fill: false,
      },
    ];
    this.chartLabels = this.salesTrendData.recordedDates.length ? this.salesTrendData.recordedDates : [];
    this.lineChartPlugins = [pluginAnnotations];
  }

  cssvar(name) {
    return getComputedStyle(document.documentElement).getPropertyValue(name);
  }

  stopInnerClick(event) {
    if (event.itemId) {
      const ddl = document.getElementById(event.itemId);
      ddl.addEventListener('click', function (events) {
        events.stopPropagation();
      });
    } else event.stopPropagation();
  }

  openClose(event) {
    const ddl = document.getElementById(event.itemId);
    if (ddl.parentElement.classList.contains('show')) {
      ddl.parentElement.classList.remove('show');
      ddl.parentElement.removeAttribute('style');
      ddl.parentElement.closest('.hover-container').classList.remove('show');
    }
  }

  chartClicked({ event, active }: { event: MouseEvent; active: {}[] }): void { }

  chartHovered({ event, active }: { event: MouseEvent; active: {}[] }): void { }

  ngOnDestroy() {
    this.subscribtions.unsubscribe();
  }

  handleClick() {
    this.chartHandleClick.emit(true);
    this.getStocks();
  }

  openPO(poData) {
    this.helperService.openPageInNewExistingTab(`/purchase-order/${poData._id}`, poData._id);
  }

  openRO(roData: any) {
    if (!roData.estimateId) return;
    this.helperService.openPageInNewExistingTab(`/estimate/${roData.estimateId}`, roData.estimateId);
  }

}
